import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AvDialogComponent } from '../Components/av-dialog/av-dialog.component';
import { AppSnackBarConfig } from '../Interfaces/snackbar.interface';

@Injectable({
  providedIn: 'root'
})
export class MsgService {

  // ========================================================================
  // on va utiliser AvDialogComponent temporairement pour les dialogs
  // ========================================================================

  modalClicked: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private translateService: TranslateService
  ) {
  }

  showPrompt(title: string, text: string, value: string) {
    const dialogRef = this.dialog.open(AvDialogComponent, {
      height: '700',
      data: { title, text, value, type: 'prompt' },
      panelClass: 'av-dialog',
    });

    return dialogRef;
  }

  /** @param buttonColor Optional: 'error' (red), 'warn', 'primary', 'accent' – e.g. 'error' for logout */
  showConfirm(title: string, text: string, subtext = '', icon = '', buttonColor?: string) {
    const panelClass = ['av-dialog', buttonColor === 'error' ? 'av-dialog-confirm--error' : ''].filter(Boolean);
    const dialogRef = this.dialog.open(AvDialogComponent, {
      data: {
        title: this.translateService.instant(title),
        text: this.translateService.instant(text),
        subtext: subtext ? this.translateService.instant(subtext) : '',
        value: true,
        type: 'confirm',
        icon,
        buttonColor
      },
      panelClass,
    });
    return dialogRef;
  }

  showAlert(title: string, text: string, icon = '') {
    const dialogRef = this.dialog.open(AvDialogComponent, {
      data: { title: this.translateService.instant(title), text: this.translateService.instant(text), type: 'alert', icon: icon },
      panelClass: 'av-dialog',
    });
    return dialogRef;
  }

  showErrorMsg(text: string, error: any, code?: number) {
    if (code && code > 499 && code < 600) {

      error = this.translateService.instant('shared.api.errors.Request_InternalServerError');
    }
    const dialogRef = this.dialog.open(AvDialogComponent, {
      data: { title: text || 'Application Error', text, type: 'alert', error: error },
      panelClass: 'av-dialog',
    });

    return dialogRef;
  }

  showSnackBar(text: string, config?: AppSnackBarConfig) {
    const type_class = config?.type ? 'snack-bar-' + config.type : 'snack-bar-success';
    this.snackBar.open(this.translateService.instant(text), this.translateService.instant('shared.general.buttons.close'), {
      duration: config?.duration ? config.duration : 5000,
      panelClass: [type_class],
      horizontalPosition: config?.horizontalPosition ? config?.horizontalPosition : 'center',
      verticalPosition: config?.verticalPosition ? config?.verticalPosition : 'bottom'
    });
  }
}
